import React from 'react';
import { Box, Chip, Typography, useTheme } from '@mui/material';
import { tokens } from '../theme';
import { useSettings } from '../contexts/SettingsContext';

const SettingsChips = ({ scoringType, platform, draftId }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const {
    liveDraftStatus,
    lastPicksUpdatedAt,
    draftId: contextDraftId,
    isSuperflex,
  } = useSettings();
  const effectiveDraftId = draftId || contextDraftId;

  const statusColorMap = {
    drafting: colors.greenAccent[600],
    paused: colors.yellowAccent ? colors.yellowAccent[600] : colors.redAccent[400],
    pre_draft: colors.blueAccent[600],
    complete: colors.grey[600],
  };
  const statusLabelMap = {
    drafting: 'Drafting',
    paused: 'Paused',
    pre_draft: 'Pre-draft',
    complete: 'Complete',
  };

  const lastUpdatedLabel = lastPicksUpdatedAt
    ? new Date(lastPicksUpdatedAt).toLocaleTimeString()
    : null;

  return (
    <Box display="flex" alignItems="center" gap={0.5} flexWrap="wrap">
      <Typography
        variant="body2"
        sx={{ color: colors.grey[100], fontSize: '12px', fontWeight: 500 }}
      >
        Settings:
      </Typography>
      <Chip
        label={
          scoringType === 'standard'
            ? 'Standard'
            : scoringType === 'ppr'
            ? 'PPR'
            : 'Half PPR'
        }
        size="small"
        sx={{
          backgroundColor: colors.greenAccent[600],
          color: colors.grey[100],
          fontSize: '12px',
          height: '20px',
          fontWeight: 'bold',
        }}
      />
      {isSuperflex && (
        <Chip
          label="2QB"
          size="small"
          sx={{
            backgroundColor: colors.yellowAccent ? colors.yellowAccent[600] : colors.blueAccent[700],
            color: colors.grey[900],
            fontSize: '12px',
            height: '20px',
            fontWeight: 'bold',
          }}
        />
      )}
      <Chip
        label={(
          { sleeper: 'Sleeper', yahoo: 'Yahoo', espn: 'ESPN', cbs: 'CBS', nfl: 'NFL' }[
            platform
          ] || platform
        )}
        size="small"
        sx={{
          backgroundColor: colors.blueAccent[600],
          color: colors.grey[100],
          fontSize: '12px',
          height: '20px',
          fontWeight: 'bold',
        }}
      />
      {effectiveDraftId && (
        <Chip
          label={`Draft: ${String(effectiveDraftId)}`}
          size="medium"
          sx={{
            backgroundColor: colors.redAccent[600],
            color: colors.grey[100],
            fontSize: '12px',
            height: '20px',
            px: 1,
            fontWeight: 'bold',
          }}
        />
      )}

      {/* Live draft status chip (only when connected) */}
      {effectiveDraftId && liveDraftStatus && (
        <Chip
          label={`Status: ${statusLabelMap[liveDraftStatus] || liveDraftStatus}`}
          size="small"
          sx={{
            backgroundColor: statusColorMap[liveDraftStatus] || colors.primary[600],
            color: colors.grey[900],
            fontSize: '12px',
            height: '20px',
            fontWeight: 'bold',
          }}
        />
      )}

      {/* Last updated chip (only when connected to a draft) */}
      {effectiveDraftId && lastUpdatedLabel && (
        <Chip
          label={`Last updated: ${lastUpdatedLabel}`}
          size="small"
          sx={{
            backgroundColor: colors.primary[600],
            color: colors.grey[100],
            fontSize: '12px',
            height: '20px',
            fontWeight: 'bold',
          }}
        />
      )}
    </Box>
  );
};

export default SettingsChips;


